import { donors } from '../queries';
import { useQuery } from 'react-apollo';

export function useDonors () {
  const { data , refetch: refresh, loading: isLoading } = useQuery(donors, {
    fetchPolicy: 'cache-first',
  });
  return {
    data: data?.donors || [],
    refresh,
    isLoading
  };
}
